import { propOr, isNil } from 'ramda'
import { capitalizeFirst } from 'utils/utils'
import {
  AS_BUILT,
  MAX_XMC_ALLOWED,
  MAX_XMC_ALLOWED_FOR_38N,
  TRUCK_SUBTYPE_38N,
  TRUCK_SUBTYPE_45X,
} from 'utils/constants'

export const formatModalHeaderPinStatus = (selectedSourcePin) => {
  if (isNil(selectedSourcePin)) {
    throw new Error('source pin not found')
  }
  const sourcePinStatus = propOr('', 'status', selectedSourcePin)
  if (sourcePinStatus === AS_BUILT) {
    const modifyText = sourcePinStatus.split('_')
    const pinTypeFirst = capitalizeFirst(modifyText[0].toLowerCase())
    const pinTypeSecond = capitalizeFirst(modifyText[1].toLowerCase())
    return `${pinTypeFirst}-${pinTypeSecond}`
  }
  return capitalizeFirst(sourcePinStatus)
}

export const getSelectedPinStatusProp = propOr('', 'status')

export const formatCardPinContent = (pinDataArray) => {
  const [pin, connector, moduleName] = pinDataArray
  return `Pin${pin}, ${connector}, ${moduleName}`
}

export const isXMCLimitReached = (
  vehicleXMCs,
  vehicleSubType,
  newXMCs = []
) => {
  const maxLimit = [TRUCK_SUBTYPE_38N, TRUCK_SUBTYPE_45X].includes(
    vehicleSubType
  )
    ? MAX_XMC_ALLOWED_FOR_38N
    : MAX_XMC_ALLOWED
  let vehicleXMCsLength = vehicleXMCs.length
  if (vehicleXMCs.length) {
    const lastXmcId =
      vehicleXMCs[vehicleXMCsLength - 1].id ||
      vehicleXMCs[vehicleXMCsLength - 1].moduleName
    const lastXmcNo = lastXmcId.charAt(lastXmcId.length - 1)
    vehicleXMCsLength = !Number.isNaN(lastXmcNo)
      ? parseInt(lastXmcNo)
      : vehicleXMCsLength
  }
  const lastNewXmcId = newXMCs[newXMCs.length - 1]?.id || '0'
  const isXMCsLengthReached =
    lastNewXmcId === '0'
      ? vehicleXMCsLength === maxLimit
      : parseInt(lastNewXmcId.charAt(lastNewXmcId.length - 1)) === maxLimit

  return { vehicleXMCsLength, isXMCsLengthReached }
}
